import ListModGeneral from './ListModulosGeneral';


export const ModulosGeneral = ({ rows, evbiOptions, reload }) => {


    return (
        <>
            {rows.map((row, index) => (
                <ListModGeneral
                    key={index}
                    modulo={row.tipoModulo.modulo}
                    estado={row.estado}
                    ultimaConexion={row.ultima_conexion}
                    ultimaMedicion={row.ultima_medicion}
                    evbi={row.evbi.name}
                    moduloid={row.id}
                    evbiOptions={evbiOptions}
                    reload={reload}
                    nombre={row.key}
                />
            ))}
        </>
    );
};
